// Simulador Emocional do Casamento - Data & Logic

export const simulatorQuestions = [
  {
    id: 1,
    category: "essência",
    question: "O que tornaria este dia verdadeiramente inesquecível para vocês?",
    subtitle: "Pensem no momento que mais vos emociona quando imaginam o vosso casamento.",
    options: [
      { id: "a", text: "Um momento íntimo e profundo, só nós dois", value: "intimate", weight: { intimate: 3, traditional: 0, social: 0, unconventional: 2 } },
      { id: "b", text: "Ver a emoção nos olhos de quem mais amamos", value: "emotional", weight: { intimate: 1, traditional: 2, social: 2, unconventional: 0 } },
      { id: "c", text: "Uma celebração grandiosa que todos recordem", value: "grand", weight: { intimate: 0, traditional: 2, social: 3, unconventional: 0 } },
      { id: "d", text: "Fazer algo completamente diferente e autêntico", value: "unique", weight: { intimate: 1, traditional: 0, social: 0, unconventional: 3 } }
    ]
  },
  {
    id: 2,
    category: "prioridades",
    question: "O que seria mais doloroso: decepcionar a família ou a vocês próprios?",
    subtitle: "Não há resposta certa. Apenas a vossa verdade.",
    options: [
      { id: "a", text: "Decepcionar a família seria muito difícil para nós", value: "family", weight: { intimate: 0, traditional: 3, social: 2, unconventional: 0 } },
      { id: "b", text: "Não conseguiríamos casar sem sermos fiéis a nós", value: "self", weight: { intimate: 2, traditional: 0, social: 0, unconventional: 3 } },
      { id: "c", text: "Procuraríamos um equilíbrio, mas a família é importante", value: "balance_family", weight: { intimate: 1, traditional: 2, social: 1, unconventional: 0 } },
      { id: "d", text: "Procuraríamos um equilíbrio, mas nós somos a prioridade", value: "balance_self", weight: { intimate: 2, traditional: 1, social: 0, unconventional: 2 } }
    ]
  },
  {
    id: 3,
    category: "atmosfera",
    question: "Preferem intimidade emocional ou impacto social?",
    subtitle: "Imaginem o ambiente que vos faria sentir mais realizados.",
    options: [
      { id: "a", text: "Intimidade total - poucas pessoas, emoção profunda", value: "intimacy", weight: { intimate: 3, traditional: 0, social: 0, unconventional: 2 } },
      { id: "b", text: "Impacto social - queremos que seja memorável para todos", value: "impact", weight: { intimate: 0, traditional: 2, social: 3, unconventional: 0 } },
      { id: "c", text: "Um equilíbrio elegante entre os dois", value: "elegant_balance", weight: { intimate: 1, traditional: 3, social: 1, unconventional: 0 } },
      { id: "d", text: "Nem um nem outro - queremos algo completamente nosso", value: "own_way", weight: { intimate: 1, traditional: 0, social: 0, unconventional: 3 } }
    ]
  },
  {
    id: 4,
    category: "ansiedade",
    question: "O que mais vos causa ansiedade quando pensam no casamento?",
    subtitle: "Identificar os medos ajuda a preveni-los.",
    options: [
      { id: "a", text: "O orçamento e não conseguir o que sonhamos", value: "budget", weight: { intimate: 1, traditional: 1, social: 2, unconventional: 1 } },
      { id: "b", text: "As expectativas e opiniões dos outros", value: "expectations", weight: { intimate: 2, traditional: 1, social: 0, unconventional: 2 } },
      { id: "c", text: "A logística e que algo corra mal no dia", value: "logistics", weight: { intimate: 0, traditional: 2, social: 2, unconventional: 0 } },
      { id: "d", text: "Perder a essência do que realmente importa", value: "essence", weight: { intimate: 2, traditional: 0, social: 0, unconventional: 3 } }
    ]
  },
  {
    id: 5,
    category: "não_negociável",
    question: "Onde sentem que não estão dispostos a ceder?",
    subtitle: "Este é o vosso ponto inegociável.",
    options: [
      { id: "a", text: "Na qualidade e elegância de cada detalhe", value: "quality", weight: { intimate: 1, traditional: 3, social: 2, unconventional: 0 } },
      { id: "b", text: "Na lista de convidados - só quem realmente importa", value: "guest_list", weight: { intimate: 3, traditional: 0, social: 0, unconventional: 2 } },
      { id: "c", text: "Na experiência dos convidados - queremos que se divirtam", value: "guest_experience", weight: { intimate: 0, traditional: 2, social: 3, unconventional: 0 } },
      { id: "d", text: "Na autenticidade - não queremos um casamento \"normal\"", value: "authenticity", weight: { intimate: 1, traditional: 0, social: 0, unconventional: 3 } }
    ]
  },
  {
    id: 6,
    category: "investimento",
    question: "Onde sentem que vale a pena investir mais?",
    subtitle: "Pensem no que vos trará mais alegria e menos arrependimento.",
    options: [
      { id: "a", text: "Fotografia e vídeo - para recordar para sempre", value: "memories", weight: { intimate: 2, traditional: 2, social: 1, unconventional: 1 } },
      { id: "b", text: "Local e decoração - o cenário perfeito", value: "venue", weight: { intimate: 1, traditional: 3, social: 2, unconventional: 0 } },
      { id: "c", text: "Gastronomia e entretenimento - a experiência", value: "experience", weight: { intimate: 0, traditional: 2, social: 3, unconventional: 1 } },
      { id: "d", text: "Lua de mel - o que vem depois é o mais importante", value: "honeymoon", weight: { intimate: 3, traditional: 0, social: 0, unconventional: 2 } }
    ]
  },
  {
    id: 7,
    category: "tradição",
    question: "Como se sentem em relação às tradições de casamento?",
    subtitle: "Não há forma certa de casar. Há a vossa forma.",
    options: [
      { id: "a", text: "Adoramos - fazem parte da magia", value: "love_traditions", weight: { intimate: 0, traditional: 3, social: 2, unconventional: 0 } },
      { id: "b", text: "Algumas sim, outras não - vamos escolher as nossas", value: "selective", weight: { intimate: 2, traditional: 1, social: 1, unconventional: 1 } },
      { id: "c", text: "Preferimos criar as nossas próprias tradições", value: "new_traditions", weight: { intimate: 2, traditional: 0, social: 0, unconventional: 3 } },
      { id: "d", text: "São importantes para a família, então incluímos", value: "family_traditions", weight: { intimate: 0, traditional: 2, social: 2, unconventional: 0 } }
    ]
  },
  {
    id: 8,
    category: "dia_perfeito",
    question: "Como imaginam o final do vosso dia de casamento?",
    subtitle: "O momento em que tudo termina e só resta o sentimento.",
    options: [
      { id: "a", text: "Sozinhos, em silêncio, a absorver tudo o que vivemos", value: "quiet_end", weight: { intimate: 3, traditional: 1, social: 0, unconventional: 2 } },
      { id: "b", text: "Rodeados de amigos, a dançar até não poder mais", value: "party_end", weight: { intimate: 0, traditional: 1, social: 3, unconventional: 1 } },
      { id: "c", text: "Com a família próxima, em conversa tranquila", value: "family_end", weight: { intimate: 1, traditional: 3, social: 1, unconventional: 0 } },
      { id: "d", text: "A começar uma aventura - fugir para algum lado especial", value: "adventure_end", weight: { intimate: 2, traditional: 0, social: 0, unconventional: 3 } }
    ]
  }
];

export const weddingProfiles = {
  intimate: {
    name: "Íntimo & Significativo",
    emoji: "🤍",
    color: "#B5C4B1",
    description: "O vosso casamento é sobre profundidade, não amplitude. Valorizam momentos genuínos sobre gestos grandiosos.",
    strengths: [
      "Conexão emocional profunda com cada convidado",
      "Liberdade para serem verdadeiramente vocês",
      "Orçamento mais focado em qualidade",
      "Menos stress logístico"
    ],
    watchOuts: [
      "Podem sentir pressão para incluir mais pessoas",
      "Familiares podem não compreender a escolha",
      "Risco de se isolarem das decisões práticas"
    ],
    recommendations: [
      "Considerem um local com significado pessoal",
      "Invistam em fotografia documental e íntima",
      "Escrevam votos pessoais - será o ponto alto",
      "Limitem a lista de convidados sem culpa"
    ],
    budgetFocus: {
      high: ["Fotografia", "Local significativo", "Lua de mel"],
      medium: ["Gastronomia de qualidade", "Flores"],
      low: ["Decoração excessiva", "Entretenimento", "Lembranças para convidados"]
    }
  },
  traditional: {
    name: "Elegante & Tradicional",
    emoji: "👑",
    color: "#D4C4B0",
    description: "Apreciam a beleza das tradições e a elegância atemporal. O vosso casamento será uma celebração refinada e memorável.",
    strengths: [
      "Clareza sobre o que querem - referências clássicas",
      "Família e amigos sentir-se-ão incluídos",
      "Estrutura que facilita o planeamento",
      "Fotografias atemporais"
    ],
    watchOuts: [
      "Podem perder-se em detalhes estéticos",
      "Orçamento pode escalar rapidamente",
      "Risco de priorizar aparência sobre substância"
    ],
    recommendations: [
      "Escolham um local clássico e elegante",
      "Invistam em fornecedores experientes",
      "Mantenham um fio condutor estético",
      "Reservem momentos só para vocês durante o dia"
    ],
    budgetFocus: {
      high: ["Local e decoração", "Fotografia profissional", "Vestido/Fato"],
      medium: ["Gastronomia", "Flores", "Música ao vivo"],
      low: ["Elementos surpresa", "Atividades não convencionais"]
    }
  },
  social: {
    name: "Celebração & Comunidade",
    emoji: "✨",
    color: "#C5D1DC",
    description: "O vosso casamento é uma festa do amor, partilhada com todos os que amam. A alegria coletiva é o vosso combustível.",
    strengths: [
      "Energia contagiante e memórias coletivas",
      "Convidados sentir-se-ão verdadeiramente parte",
      "Momentos espontâneos e divertidos",
      "Uma celebração que todos recordarão"
    ],
    watchOuts: [
      "Podem sentir-se \"anfitriões\" em vez de \"noivos\"",
      "Lista de convidados pode tornar-se difícil de gerir",
      "Risco de não terem tempo de qualidade a dois"
    ],
    recommendations: [
      "Planeiem momentos só para vocês durante o dia",
      "Invistam fortemente em entretenimento",
      "Escolham um local que permita movimento",
      "Contratem coordenação do dia para relaxarem"
    ],
    budgetFocus: {
      high: ["Catering e bebidas", "Música e entretenimento", "Local espaçoso"],
      medium: ["Decoração festiva", "Fotografia e vídeo"],
      low: ["Detalhes muito íntimos", "Elementos simbólicos elaborados"]
    }
  },
  unconventional: {
    name: "Livre & Autêntico",
    emoji: "🌿",
    color: "#E8D5D5",
    description: "Recusam-se a seguir um guião que não é vosso. O vosso casamento será uma expressão pura de quem são.",
    strengths: [
      "Total liberdade criativa",
      "Zero arrependimentos por não serem autênticos",
      "Experiência única e memorável",
      "Menos pressão de expectativas externas"
    ],
    watchOuts: [
      "Podem encontrar resistência de familiares",
      "Fornecedores podem não compreender a visão",
      "Risco de planear em oposição em vez de em afirmação"
    ],
    recommendations: [
      "Encontrem fornecedores que partilhem a vossa visão",
      "Comuniquem claramente com a família",
      "Foquem-se no que querem, não no que não querem",
      "Considerem um elopement ou micro wedding"
    ],
    budgetFocus: {
      high: ["Experiência única", "Viagem/Destino", "Elementos personalizados"],
      medium: ["Fotografia artística", "Catering criativo"],
      low: ["Elementos tradicionais", "Decoração convencional", "Lista extensa de convidados"]
    }
  }
};

export const calculateProfile = (answers) => {
  const scores = {
    intimate: 0,
    traditional: 0,
    social: 0,
    unconventional: 0
  };

  // Calculate scores based on answers
  answers.forEach(answer => {
    if (answer.weight) {
      Object.keys(answer.weight).forEach(profile => {
        scores[profile] += answer.weight[profile];
      });
    }
  });

  // Find primary and secondary profiles
  const sortedProfiles = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const primaryProfile = sortedProfiles[0][0];
  const secondaryProfile = sortedProfiles[1][0];
  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);

  // Calculate percentages
  const percentages = {};
  Object.keys(scores).forEach(profile => {
    percentages[profile] = Math.round((scores[profile] / totalScore) * 100);
  });

  return {
    primary: primaryProfile,
    secondary: secondaryProfile,
    scores,
    percentages,
    profile: weddingProfiles[primaryProfile],
    secondaryProfile: weddingProfiles[secondaryProfile]
  };
};

export const generatePriorityMap = (answers, profile) => {
  const priorities = {
    high: [],
    medium: [],
    low: []
  };

  // Based on specific answers, generate priorities
  const anxietyAnswer = answers.find(a => a.category === "ansiedade");
  const investmentAnswer = answers.find(a => a.category === "investimento");
  const nonNegotiableAnswer = answers.find(a => a.category === "não_negociável");

  if (anxietyAnswer) {
    switch (anxietyAnswer.value) {
      case "budget":
        priorities.high.push("Definir orçamento realista desde o início");
        break;
      case "expectations":
        priorities.high.push("Estabelecer limites saudáveis com familiares");
        break;
      case "logistics":
        priorities.high.push("Contratar coordenação profissional do dia");
        break;
      case "essence":
        priorities.high.push("Criar momentos de conexão genuína durante o dia");
        break;
    }
  }

  if (investmentAnswer) {
    switch (investmentAnswer.value) {
      case "memories":
        priorities.high.push("Investir em fotografia e videografia de qualidade");
        break;
      case "venue":
        priorities.high.push("Priorizar o local e a decoração");
        break;
      case "experience":
        priorities.high.push("Focar na experiência gastronómica e entretenimento");
        break;
      case "honeymoon":
        priorities.high.push("Reservar parte significativa do orçamento para a lua de mel");
        break;
    }
  }

  if (nonNegotiableAnswer) {
    switch (nonNegotiableAnswer.value) {
      case "quality":
        priorities.medium.push("Escolher fornecedores premium em áreas-chave");
        break;
      case "guest_list":
        priorities.medium.push("Manter lista de convidados restrita e significativa");
        break;
      case "guest_experience":
        priorities.medium.push("Garantir conforto e entretenimento dos convidados");
        break;
      case "authenticity":
        priorities.medium.push("Personalizar cada elemento do casamento");
        break;
    }
  }

  // Add profile-based priorities
  priorities.low = [
    ...profile.budgetFocus.low.slice(0, 2).map(item => `Poupar em: ${item}`)
  ];

  return priorities;
};

export const generateAlerts = (answers, profileResult) => {
  const alerts = [];

  // Based on profile combination
  if (profileResult.primary === "intimate" && profileResult.percentages.social > 20) {
    alerts.push({
      type: "attention",
      title: "Tensão entre intimidade e socialização",
      message: "Valorizam a intimidade mas também querem que outros participem. Considerem um casamento em duas partes: cerimónia íntima e festa mais alargada."
    });
  }

  if (profileResult.primary === "unconventional" && profileResult.percentages.traditional > 25) {
    alerts.push({
      type: "attention",
      title: "Equilíbrio entre autenticidade e tradição",
      message: "Querem ser diferentes mas também respeitam certas tradições. Escolham conscientemente quais manter e quais reinventar."
    });
  }

  // Based on anxiety answer
  const anxietyAnswer = answers.find(a => a.category === "ansiedade");
  if (anxietyAnswer?.value === "expectations") {
    alerts.push({
      type: "warning",
      title: "Atenção às expectativas externas",
      message: "Este perfil de casal tende a sofrer com pressão de familiares e amigos. Estabeleçam limites claros desde o início e comuniquem as vossas decisões com confiança."
    });
  }

  if (anxietyAnswer?.value === "budget") {
    alerts.push({
      type: "tip",
      title: "Gestão financeira consciente",
      message: "Definam o orçamento máximo antes de começar a planear e dividam-no por categorias. Isto evitará surpresas e decisões emocionais."
    });
  }

  // Profile-specific alerts
  if (profileResult.primary === "social") {
    alerts.push({
      type: "tip",
      title: "Não se esqueçam de vocês",
      message: "Casais com foco na celebração coletiva por vezes esquecem-se de reservar momentos só para eles. Planeiem uma \"first look\" privada ou um jantar só os dois na véspera."
    });
  }

  return alerts;
};
